import React from 'react';
import { Button } from './ui/Button';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheckIcon, CreditCardIcon, MailIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="compra" className="py-20 px-4 scroll-mt-20" data-id="element-95">
      <div className="max-w-4xl mx-auto" data-id="element-96">
        <div className="bg-white rounded-3xl p-8 md:p-12 border-2 border-[#D4850A] shadow-[0_0_50px_rgba(212,133,10,0.1)] relative overflow-hidden" data-id="element-97">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 bg-red-600 text-white px-6 py-2 rounded-bl-3xl font-bold uppercase tracking-wider shadow-lg" data-id="element-98">
            Oferta Especial
          </div>

          <div className="text-center mb-10 pt-8" data-id="element-99">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#3D2B1F]" data-id="element-100">
              Accedé a todo el pack completo por solo:
            </h2>

            <div className="flex flex-col items-center justify-center mb-6" data-id="element-101">
              <span className="text-2xl text-[#9B8578] line-through mb-2" data-id="element-102">
                Precio normal: $39.990
              </span>
              <div className="flex items-start justify-center text-[#D4850A] font-extrabold" data-id="element-103">
                <span className="text-4xl mt-2" data-id="element-104">$</span>
                <span className="text-7xl md:text-8xl tracking-tighter" data-id="element-105">
                  19.990
                </span>
                <span className="text-2xl mt-auto mb-2 ml-2" data-id="element-106">ARS</span>
              </div>
            </div>

            <div className="flex flex-wrap justify-center gap-4 text-[#6B5344] font-medium text-lg mb-10" data-id="element-107">
              <span className="flex items-center gap-2" data-id="element-108">
                <CreditCardIcon className="w-5 h-5 text-[#D4850A]" data-id="element-109" /> Pago
                único.
              </span>
              <span className="flex items-center gap-2" data-id="element-110">
                <MailIcon className="w-5 h-5 text-[#D4850A]" data-id="element-111" /> Acceso
                inmediato.
              </span>
              <span className="flex items-center gap-2" data-id="element-112">
                <ShieldCheckIcon className="w-5 h-5 text-[#D4850A]" data-id="element-113" /> Descarga
                instantánea.
              </span>
            </div>
          </div>

          <div className="text-center mb-10" data-id="element-114">
            <Button href="http://checkout.sabores365.online/cart/59169162362961:1" size="xl" className="w-full md:w-auto text-2xl py-6 px-12 shadow-[0_0_30px_rgba(212,133,10,0.3)] animate-pulse" data-id="element-115">
              COMPRAR AHORA - $19.990 ARS
            </Button>
            <p className="text-sm text-[#9B8578] mt-4 flex items-center justify-center gap-2" data-id="element-116">
              <ShieldCheckIcon className="w-4 h-4" data-id="element-117" /> Pago 100% seguro y
              encriptado
            </p>
          </div>

          <div className="bg-[#FEF3E2] rounded-2xl p-6 border border-[#E8D5C4] text-center" data-id="element-118">
            <p className="text-red-500 font-bold mb-4 uppercase tracking-wider" data-id="element-119">
              La oferta termina en:
            </p>
            <CountdownTimer size="md" data-id="element-120" />
          </div>
        </div>
      </div>
    </section>;
}